<template>
	<div name="mainpopup" class="main-popup">
		<div class="wrapper" v-if="view">
			<!-- <div class="popup-body">
				<img class="img logo" src="../../assets/popup/logo_soldoc_sm@2x.png" alt="soldoc+" />
				<h2 class="title"><strong>솔닥 비대면진료</strong> 자격 대폭 확대 안내</h2>
				<span class="date">2023년 12월 15일부터 시행</span>
				<ul class="list list-box">
					<li>야간(오후 6시-오전 9시) 및 공휴일은 <strong>누구나 비대면진료</strong>를 볼 수 있어요</li>
					<li class="bg-red">6개월 이내 대면 진료한 병원에서는 <strong>언제든 비대면진료</strong>를 볼 수 있어요</li>
				</ul>
			</div>
			<div class="btn-area">
				<a href="https://soldoc.co.kr/view?id=16" target="_blank" class="btn-text"
					>관련 내용 <strong>자세히 보기</strong></a
				>
			</div> -->
			<div class="popup-body">
        <a href="https://concierge.soldoc.co.kr/barocarenew?utm_source=soldoc_web&utm_medium=popup_banner&utm_campaign=dm_0501&utm_content=dm_0501&utm_term=dm_0501" target="_blank">
          <img class="img" src="../../assets/popup/soldoc/20250507/popup_pc_event1.png" alt="솔닥 컨시어지 (다음 내용 참조)" />
        </a>
				<div class="sr-only">
					<h2>솔닥 컨시어지</h2>
					<p>솔닥 컨시어지 찾아 오셨다면 여기로 오세요</p>
					<ul>
						<li>
							<dl>
								<dt>솔닥 컨시어지</dt>
								<dd>1형 당뇨 맞춤 서비스 바로가기</dd>
							</dl>
						</li>
					</ul>
<!--					<span>* 당일배송 지역은 솔닥 앱 > 마이페이지 > 공지사항 참고</span>-->
<!--					<p>이후 접수 건은 <strong>8/16(금) 부터 순차 출고</strong></p>-->
<!--					<p>광복절에도 문 연 병원, 솔닥 앱에서 알아보세요!!</p>-->
					<span>soldoc+</span>
				</div>
			</div>

      <!-- 오늘 하루 보지 않기 -->
      <div class="bottom">
				<span class="checkbox-wrapper">
					<input id="today" type="checkbox" v-model="doNotShowToday">
					<label for="today" class="checkbox-text">오늘 하루 보지 않기</label>
				</span>
        <button type="button" :class="['button', pageButtonClass]" @click="close"><i class="ico-close"></i></button>
      </div>

		</div>
	</div>
</template>

<script>
import cookies from "@/utilities/cookie.js";

export default {
	name: "mainpopup",
	data: function() {
		return {
			view: false,
      doNotShowToday: false,
		};
	},
	props: {
		pageButtonClass: {
			type: String,
			default: ""
		}
	},
	mounted: function() {
		// 쿠키에 데이터 여부 확인
		// today == false 면 보이기
		// today == true 면 today의 유효기간 체크
		// today 의 유효기간(1)이 지났으면 보이기
		// 지나지 않았으면 안보이기
		this.view = cookies.getCookie("soldoc-today");

		if (this.view === "false") {
			this.view = false;
		} else {
			this.view = true;
		}
	},
	methods: {
		close: function() {
      if (this.doNotShowToday) {
        cookies.setCookie("today", false);
      }
      this.view = false;
		},
		goSoldocGuide: function() {
			window.open(
				"https://www.mohw.go.kr/react/al/sal0101vw.jsp?PAR_MENU_ID=04&MENU_ID=040101&page=1&CONT_SEQ=376488",
				"_blank"
			);
		}
	}
};
</script>

<style scoped>
.main-popup {
  position:absolute;
  width: 100%;
  min-width: 960px;
  max-width: 1320px;
  background:red;
}
.wrapper {
	position: fixed;
	top: 200px;
	left: calc(((100% - 1320px) / 2) + 20px);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	/* width: 366px; */
	width: 330px;
	z-index: 999;
}

@media (max-width:1320px) {
  .wrapper {
    left: 20px;
  }
}

.popup-body {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	/* height: 418px; */
	/* padding: 34px 20px; */
	background: #f8f9ff;
}

.img {
	width: 100%;
}

.ico-close {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-top: 4px;
  background: url(../../assets/popup/ico_close_white.png) no-repeat center/cover;
}

.popup-body .logo {
	width: 53px;
	text-align: center;
}
.popup-body .title {
	margin: 19px 0 15px;
	font-family: "Pretendard";
	font-size: 33px;
	font-weight: 600;
	color: #1a1a1a;
	text-align: center;
}
.popup-body .title strong {
	display: block;
	font-weight: 600;
	color: #1f70ff;
}
.popup-body .date {
	font-size: 19px;
	font-weight: 600;
	text-align: center;
	color: #1a1a1a;
}
.popup-body .list {
	width: 100%;
	margin: 24px 0 35px;
	padding: 0;
	font-family: "Pretendard";
	font-size: 17px;
	font-weight: 400;
	line-height: 26px;
	color: #1a1a1a;
	list-style-type: none;
}
.popup-body .list-box li {
	position: relative;
	width: 100%;
	height: 79px;
	padding: 13px 30px 14px 48px;
	border-radius: 8px;
	background: #e6edff;
}
.popup-body .list-box li strong {
	font-weight: 600;
}
.popup-body .list-box li + li {
	margin-top: 15px;
}
.popup-body .list-box li:before {
	position: absolute;
	top: 17px;
	left: 17px;
	width: 20px;
	height: 20px;
	background: url(../../assets/popup/ico_bullet_blue.png);
	content: "";
}
.popup-body .list-box .bg-red {
	background: #f6dfd9;
}
.popup-body .list-box .bg-red:before {
	background: url(../../assets/popup/ico_bullet_red.png);
}
.wrapper .btn-area {
	width: 100%;
}
.wrapper .btn-area .btn-text {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 66px;
	background: #1a1a1a;
	font-size: 18px;
	font-weight: 400;
	line-height: 26px;
	color: #fff;
}
.wrapper .btn-text strong {
	display: inline;
	padding-left: 5px;
	font-weight: 700;
}
.wrapper .btn-text:hover {
	text-decoration: none;
}

.wrapper .bottom {
  height: 32px;
  width: 100%;
  background: #1a1a1a;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 11px;
}
.bottom button {
  padding:0;
  border:0;
  color: inherit;
  background: transparent;
  line-height: 16px;
}
.checkbox-wrapper {
  display: flex;
  align-items: center;
  margin-right: 10px;
  cursor: pointer;
}
.checkbox-wrapper input[type="checkbox"] {
  display: none;
}
.checkbox-wrapper input[type="checkbox"] + label {
  cursor: pointer;
}
.checkbox-wrapper input[type="checkbox"] + label:before {
  content: '';
  display: inline-block;
  width: 14px;
  height: 14px;
  background: url(../../assets/popup/ico_uncheck_black.png) no-repeat center/cover;
}
.checkbox-wrapper input[type="checkbox"]:checked + label:before {
  background-image: url(../../assets/popup/ico_check_black.png);
}
.checkbox-text {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: -0.02em;
  margin-bottom: 0;
  gap: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc_main/MainPopup.vue